import { render, staticRenderFns } from "./TextNumText.vue?vue&type=template&id=82d8247a&"
import script from "./TextNumText.vue?vue&type=script&lang=js&"
export * from "./TextNumText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports